// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home_home__9Ke73 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.Home_home__9Ke73 .Home_bg__kw-07 {
  position: absolute;
  inset: -1px;
  height: 100vh;
  width: 100vw;
  z-index: -1;
  outline: hidden;
}
.Home_home__9Ke73 .Home_bg__kw-07 img {
  height: 100vh;
  width: 100vw;
  object-fit: cover;
  object-position: center !important;
}
.Home_home__9Ke73 .Home_bg__kw-07 .Home_box_filter__Gnq7V {
  position: absolute;
  inset: 0;
  background: rgba(27, 0, 0, 0.5);
}
.Home_home__9Ke73 .Home_content__qrD-\\+ {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-right: 15%;
}
@media (max-width: 1060px) {
  .Home_home__9Ke73 .Home_content__qrD-\\+ {
    padding-right: 5%;
  }
}
@media (max-width: 640px) {
  .Home_home__9Ke73 .Home_content__qrD-\\+ {
    padding-right: 0;
  }
}
.Home_home__9Ke73 .Home_content__qrD-\\+ .Home_box_logo__spPR7 {
  text-align: end;
}
.Home_home__9Ke73 .Home_content__qrD-\\+ .Home_box_logo__spPR7 .Home_logo__s21Dj {
  max-width: 45.8333rem;
  width: 100%;
}
@media (max-width: 640px) {
  .Home_home__9Ke73 .Home_content__qrD-\\+ .Home_box_logo__spPR7 .Home_logo__s21Dj {
    max-width: auto;
    width: 145%;
    margin-left: -20%;
  }
}
.Home_home__9Ke73 .Home_content__qrD-\\+ .Home_box_logo__spPR7 h1 {
  color: #F6F6F6;
  font-size: 5.4rem;
  font-family: "Rubik Glitch", cursive;
  font-weight: 400;
  margin: -3.75rem 40px 100px 0;
}
@media (max-width: 790px) {
  .Home_home__9Ke73 .Home_content__qrD-\\+ .Home_box_logo__spPR7 h1 {
    font-size: 4.4rem;
    margin: -2.5rem 40px 100px 0;
  }
}
@media (max-width: 640px) {
  .Home_home__9Ke73 .Home_content__qrD-\\+ .Home_box_logo__spPR7 h1 {
    font-size: 3.7rem;
    text-align: center;
    margin: -1.5rem auto 100px auto;
  }
}
@media (max-width: 370px) {
  .Home_home__9Ke73 .Home_content__qrD-\\+ .Home_box_logo__spPR7 h1 {
    font-size: 3rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/Home.module.scss"],"names":[],"mappings":"AAAA;EAEG,aAAA;EACA,mBAAA;EACA,uBAAA;AAAH;AAEG;EACG,kBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AAAN;AAEM;EACG,aAAA;EACA,YAAA;EACA,iBAAA;EACA,kCAAA;AAAT;AAGM;EACG,kBAAA;EACA,QAAA;EACA,+BAAA;AADT;AAKG;EACG,WAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAHN;AAKM;EATH;IAUM,iBAAA;EAFP;AACF;AAGM;EAZH;IAaM,gBAAA;EAAP;AACF;AAGM;EACG,eAAA;AADT;AAGS;EACG,qBAAA;EACA,WAAA;AADZ;AAGY;EAJH;IAKM,eAAA;IACA,WAAA;IACA,iBAAA;EAAb;AACF;AAES;EACG,cAAA;EACA,iBAAA;EACA,oCAAA;EACA,gBAAA;EACA,6BAAA;AAAZ;AAEY;EAPH;IAQM,iBAAA;IACA,4BAAA;EACb;AACF;AACY;EAZH;IAaM,iBAAA;IACA,kBAAA;IACA,+BAAA;EAEb;AACF;AAAY;EAlBH;IAmBM,eAAA;EAGb;AACF","sourcesContent":[".home {\r\n\r\n   display: flex;\r\n   align-items: center;\r\n   justify-content: center;\r\n\r\n   .bg {\r\n      position: absolute;\r\n      inset: -1px;\r\n      height: 100vh;\r\n      width: 100vw;\r\n      z-index: -1;\r\n      outline: hidden;\r\n\r\n      img {\r\n         height: 100vh;\r\n         width: 100vw;\r\n         object-fit: cover;\r\n         object-position: center !important;\r\n      }\r\n\r\n      .box_filter {\r\n         position: absolute;\r\n         inset: 0;\r\n         background: rgba(27, 0, 0, 0.50);\r\n      }\r\n   }\r\n\r\n   .content {\r\n      width: 100%;\r\n      min-height: 100vh;\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: center;\r\n      justify-content: center;\r\n      padding-right: 15%;\r\n\r\n      @media (max-width: 1060px) {\r\n         padding-right: 5%;\r\n      }\r\n      @media (max-width: 640px) {\r\n         padding-right: 0;\r\n         // min-height: 72vh;\r\n      }\r\n\r\n      .box_logo{\r\n         text-align: end;\r\n\r\n         .logo {\r\n            max-width: 45.8333rem;\r\n            width: 100%;\r\n\r\n            @media (max-width: 640px) {\r\n               max-width: auto;\r\n               width: 145%;\r\n               margin-left: -20%;\r\n            }\r\n         }\r\n         h1 {\r\n            color: #F6F6F6;\r\n            font-size: 5.4rem;\r\n            font-family: 'Rubik Glitch', cursive;\r\n            font-weight: 400;\r\n            margin: -3.75rem 40px 100px 0;\r\n\r\n            @media (max-width: 790px) {\r\n               font-size: 4.4rem;\r\n               margin: -2.5rem 40px 100px 0;\r\n            }\r\n\r\n            @media (max-width: 640px) {\r\n               font-size: 3.7rem;\r\n               text-align: center;\r\n               margin: -1.5rem auto 100px auto;\r\n            }\r\n\r\n            @media (max-width: 370px) {\r\n               font-size: 3rem;\r\n            }\r\n         }\r\n      }\r\n   }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home": `Home_home__9Ke73`,
	"bg": `Home_bg__kw-07`,
	"box_filter": `Home_box_filter__Gnq7V`,
	"content": `Home_content__qrD-+`,
	"box_logo": `Home_box_logo__spPR7`,
	"logo": `Home_logo__s21Dj`
};
export default ___CSS_LOADER_EXPORT___;
